import { ISimpleSelectItem } from 'components/select/SimpleSelect';
import { PaymentReminderType } from 'src/types/enums';

export const REMINDER_TYPE_SELECT_OPTIONS: ISimpleSelectItem[] = [
  { key: PaymentReminderType.FirstReminder, name: 'Eerste herinnering' },
  { key: PaymentReminderType.SecondReminder, name: 'Tweede herinnering' },
  { key: PaymentReminderType.ThirdReminder, name: 'Derde herinnering' },
  { key: PaymentReminderType.FourthReminder, name: 'Laatste herinnering' },
];
